import axiosInstance from "./axiosInstance";

export interface HourReportingWorkflow {
    id: string;
    workerId: string;
    sourcePhoneNumber: string;
    workflowState: string;
    status: string;
    updatedAt: string;
    createdAt: string;
    placementLabel?: string | null;
    currentComment?: string | null;
    workflowLanguage?: string | null;
    workflowContext?: Record<string, any> | null;
    operatorStatus: {
        linkedByPhone: boolean;
        easyflexLinkPresent: boolean;
        imageSubmitted: boolean;
        textSubmitted?: boolean;
        extracted: boolean;
        userConfirmed: boolean;
        approvalStatus?: string | null;
        easyflexSyncStatus?: string | null;
        aiPaused: boolean;
        adminIntervention: boolean;
        draftValidationSummary?: string | null;
    };
}

export interface HourReportingWorkflowDetail {
    workflow: HourReportingWorkflow & Record<string, any>;
    events: Array<Record<string, any>>;
}

const BASE = "/timesheets/operator/workflows";

export async function listHourReportingWorkflows(limit = 100): Promise<HourReportingWorkflow[]> {
    const response = await axiosInstance.get<HourReportingWorkflow[]>(BASE, { params: { limit } });
    return response.data;
}

export async function getHourReportingWorkflow(id: string): Promise<HourReportingWorkflowDetail> {
    const response = await axiosInstance.get<HourReportingWorkflowDetail>(`${BASE}/${id}`);
    return response.data;
}

export async function pauseHourReportingWorkflow(id: string): Promise<void> {
    await axiosInstance.post(`${BASE}/${id}/pause`);
}

export async function resumeHourReportingWorkflow(id: string): Promise<void> {
    await axiosInstance.post(`${BASE}/${id}/resume`);
}

export async function sendHourReportingAdminMessage(id: string, message: string): Promise<void> {
    await axiosInstance.post(`${BASE}/${id}/admin-message`, { message });
}

export async function approveHourReportingWorkflow(id: string): Promise<void> {
    await axiosInstance.post(`${BASE}/${id}/approve`);
}
